import { Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useTransactionDrawerContext } from '../../contexts/TransactionDrawerContext'
import { DrawerSection } from '../DrawerSection'

export const DescriptionSection = () => {
  const { t } = useTranslation()
  const { originatorName } = useTransactionDrawerContext()

  return (
    <DrawerSection title={t('ledger.description')}>
      <Text>{originatorName}</Text>
    </DrawerSection>
  )
}
